<script setup lang="ts">
  import { computed, ref, watch } from 'vue'
  import { stringifyQuery, useRoute } from 'vue-router'

  defineProps<{
    loading?: boolean,
    disabled?: boolean,
  }>()

  const emit = defineEmits<{
    click: [],
  }>()

  const route = useRoute()
  const applied = ref(false)
  const appliedFilterQuery = ref('')

  const filterQuery = computed(() => {
    return stringifyQuery({
      ...route.query,
      page: undefined,
      per_page: undefined,
    })
  })

  const apply = () => {
    applied.value = true
    appliedFilterQuery.value = filterQuery.value
    emit('click')
  }
  defineExpose({ apply })

  // const isSameQueryValue = (a: unknown, b: unknown) => {
  //   if (Array.isArray(a) || Array.isArray(b)) {
  //     return JSON.stringify(a ?? null) === JSON.stringify(b ?? null)
  //   }

  //   return a === b
  // }

  watch(() => route.query, (newQuery, oldQuery) => {
    const keys = new Set([...Object.keys(newQuery), ...Object.keys(oldQuery)])
    const changedKeys = [...keys].filter((key) => newQuery[key] !== oldQuery[key])

    const somethingChanged = changedKeys.length > 0

    const onlyPageOrPerPageChanged = changedKeys.every((key) => key === 'page' || key === 'per_page')
    if (somethingChanged && onlyPageOrPerPageChanged) {
      emit('click')
    }
  })
</script>

<template>
  <app-submit
    class="btn-primary self-end"
    :loading="loading"
    :disabled="disabled"
    @click="apply">
    <slot></slot>
  </app-submit>
</template>
